import { AccountType } from "plaid";
import { FinancialItemType } from "../models/FinancialItemType";
import { FinancialItemForm } from "../models/Forms/FinancialItemForm";

export type FinancialItemFormDefaults = FinancialItemForm & {
  accountType?: AccountType;
};

export const financialItemFormDefaults: Record<
  FinancialItemType,
  FinancialItemFormDefaults
> = {
  real_estate: {
    category: "asset",
    amount: 0,
    associatedDebtAmount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Loan, // tied to mortgage typically
  },
  household_items: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  jewelry_antiques_art: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  vehicles_boats_trailers: {
    category: "asset",
    amount: 0,
    associatedDebtAmount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  savings_account: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Depository,
  },
  checking_account: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Depository,
  },
  credit_union_account: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Depository,
  },
  cash: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  tax_refund: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  life_insurance_cash_value: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  securities_stocks_bonds: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Investment,
  },
  retirement_pension: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Investment,
  },
  annuities_iras_deferred_comp: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Investment,
  },
  accounts_receivable_notes: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  business_interest: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  other_asset: {
    category: "asset",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  student_loan: {
    category: "liability",
    name: "Student Loan",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Loan,
  },
  taxes_due: {
    category: "liability",
    name: "Taxes Due",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  support_arrearage: {
    category: "liability",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
  unsecured_loan: {
    category: "liability",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Loan,
  },
  credit_card_debt: {
    category: "liability",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
    accountType: AccountType.Credit,
  },
  other_debt: {
    category: "liability",
    amount: 0,
    currency: "USD",
    ownershipStatus: "marital",
    ownershipPercentage: 50,
  },
};
